export default "__VITE_ASSET__C8oMLAT1__"